const LangAddCard = {
	"addCard._title": ["ADD A CARD", "បន្ថែម​កាត"],
	"addCard.form.button._addCard": ["Add Card", "បន្ថែម​កាត"],
}

export default LangAddCard



// WEBPACK FOOTER //
// ./src/resources/pages/LangAddCard.js